let firebaseConfig, serviceRoot, functionsRoot;
let newDisplayPostSecs = 600;

if (__DEV__ || __LOCAL__) {
    firebaseConfig = {
        apiKey: "AIzaSyAuHNUrnGEGL20iixervn9fk_gi4P2C1Ag",
        authDomain: "shtum-dev.firebaseapp.com",
        databaseURL: "https://shtum-dev.firebaseio.com",
        projectId: "shtum-dev",
        storageBucket: "shtum-dev.appspot.com",
        messagingSenderId: "53507621769",
        appId: "1:53507621769:web:cb03286a86b51be6da9758",
        measurementId: "G-6SJ4108YFV"
    }
}

if (__TEST__) {
    firebaseConfig = {
        apiKey: "AIzaSyApbAIpdJpBCNkukXJdA1FgjyWTxzk6C58",
        authDomain: "shtum-test.firebaseapp.com",
        databaseURL: "https://shtum-test.firebaseio.com",
        projectId: "shtum-test",
        storageBucket: "shtum-test.appspot.com",
        messagingSenderId: "1068081670760",
        appId: "1:1068081670760:web:4dcec6ce0f822b7d65e9dd",
        measurementId: "G-SGV9674PRY"
    }
}

if (__PROD__ || __LOCAL_LIVE__) {
    firebaseConfig = {
        apiKey: "AIzaSyBxBsPJwgQnfVnI0-Obi2YUbuL3M_wElzQ",
        authDomain: "shtum.firebaseapp.com",
        databaseURL: "https://shtum.firebaseio.com",
        projectId: "project-6857976610930136836",
        storageBucket: "project-6857976610930136836.appspot.com",
        messagingSenderId: "785547435633",
        appId: "1:785547435633:web:fe73182abb66a71c0dc5d0",
        measurementId: "G-WFHQL1HXJJ"
    }
}

if (__LOCAL__) {
    serviceRoot = 'http://localhost:8088/'
    functionsRoot = 'https://us-central1-shtum-dev.cloudfunctions.net/'
}

if (__LOCAL_LIVE__) {
    serviceRoot = 'http://localhost:8088/'
    functionsRoot = 'https://us-central1-project-6857976610930136836.cloudfunctions.net/'
}

if (__DEV__) {
    serviceRoot = 'https://shtum-dev.herokuapp.com/'
    functionsRoot = 'https://us-central1-shtum-dev.cloudfunctions.net/'
}

if (__TEST__) {
    serviceRoot = 'https://shtum-test.herokuapp.com/'
    functionsRoot = 'https://us-central1-shtum-test.cloudfunctions.net/'
}

if (__PROD__) {
    serviceRoot = 'https://shtum.herokuapp.com/'
    functionsRoot = 'https://us-central1-project-6857976610930136836.cloudfunctions.net/'
}


if (__LOCAL__ || __DEV__ || __TEST__) {
    console.log("The __LOCAL__ variable = " + __LOCAL__)
    console.log("The __DEV__ variable = " + __DEV__)
    console.log("The __TEST__ variable = " + __TEST__)
    console.log("The __PROD__ variable = " + __PROD__)

    console.log("serviceRoot = " + serviceRoot)
}

export {firebaseConfig, serviceRoot, functionsRoot, newDisplayPostSecs}
